import { brandDataService } from "./services";
import { ItemPage, LibraryCard } from "./components";
import {
  AddButton,
  BackButton,
  CancelButton,
  DeleteButton,
  EditButton,
  SaveButton,
} from "./components/toolbar-items";
import { faCopyright } from "@fortawesome/free-solid-svg-icons";
import { ModuleTypeEnum } from "../../enums";
import { IModuleConfig } from "../../interfaces";

const config: IModuleConfig = {
  id: "brands",
  name: "Brands",
  icon: faCopyright,
  moduleType: ModuleTypeEnum.DualPaneLibrary,
  allowSearch: true,
  services: {
    getByPage: brandDataService.getByPage,
    getSingle: brandDataService.getSingle,
    search: brandDataService.search,
    create: brandDataService.create,
    update: brandDataService.update,
    delete: brandDataService.delete,
    getAll: brandDataService.getAll,
  },
  components: {
    libraryCard: LibraryCard,
    itemPage: ItemPage,
  },
  utilities: {
    extractKey: (d: any) => d.id,
    extractItemPath: (d: any) => d.id,
    extractItemBreadcrumb: (d: any) => `${d.name}`,
  },
  // Add toolbar items in order they should render in the toolbar
  toolbarItems: {
    library: [AddButton],
    view: [BackButton, "|", EditButton, DeleteButton],
    edit: [SaveButton, CancelButton],
    create: [],
  },
};

export default config;
